import { VoucherOfflineStatus } from "models";
import { t } from "utils/i18n";
import commonConstants from "./common";

const { TK_STATUS_COLOR } = commonConstants;

const STATUS_MAP: Record<VoucherOfflineStatus, { color: string; label: string }> = {
  [VoucherOfflineStatus.ACTIVE]: { color: TK_STATUS_COLOR.SUCCESS, label: t("VoucherOfflineList.StatusActive") },
  [VoucherOfflineStatus.USED]: { color: TK_STATUS_COLOR.DEFAULT, label: t("VoucherOfflineList.StatusUsed") },
  [VoucherOfflineStatus.EXPIRED]: { color: TK_STATUS_COLOR.ERROR, label: t("VoucherOfflineList.StatusExpired") },
};

export default {
  STATUS_MAP,
};
